import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";
import TestsRequests from "services/tests";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddKeyDialog({ open, handleClose }) {
  const [count, setcount] = useState(0);
  const [description, setDescription] = useState("");
  const [type, setType] = useState("JoftPooch");
  const [score, setScore] = useState(0);
  const [coin, setCoin] = useState(0);

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleAddUserAccess = () => {
    const req = {
      count: count,
      description: description,
      type: type,
      prize: [],
    };
    if (score) {
      req.prize.push({
        value: score,
        type: "JoftPoochScore",
      });
    }
    if (coin) {
      req.prize.push({
        value: coin,
        type: "JoftPoochCoin",
      });
    }
    dispatch(TestsRequests.addKey(req));
    handleClose();
    reset();
  };

  const reset = () => {
    setcount("");
    setDescription("");
    setType("JoftPooch");
    setScore(0);
    setCoin(0);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-user-access"
      aria-describedby="alert-add-user-access"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-description">
          اضافه کردن کلید
        </DialogContentText>
        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12} md={6} className={classes.inputContainer}>
            <Typography>تعداد</Typography>
            <TextField
              id="CountInput"
              label="تعداد"
              type="number"
              variant="outlined"
              className={classes.customInput}
              value={count}
              onChange={(e) => setcount(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.inputContainer}>
            <Typography>توضیحات</Typography>
            <TextField
              id="descriptionInput"
              label="توضیحات"
              variant="outlined"
              className={classes.customInput}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={12} className={classes.inputContainer}>
            <Typography>نوع</Typography>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="relation-select-outlined-label">نوع</InputLabel>
              <Select
                labelId="relation-select-outlined-label"
                id="relation-select-outlined"
                value={type}
                onChange={(e) => setType(e.target.value)}
                label="نوع"
              >
                <MenuItem value={"JoftPooch"}>جفت پوچ</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} className={classes.inputContainer}>
            <Typography>پله</Typography>
            <TextField
              id="scoreInput"
              label="پله"
              variant="outlined"
              className={classes.customInput}
              value={score}
              onChange={(e) => setScore(e.target.value)}
              type="number"
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.inputContainer}>
            <Typography>کلید</Typography>
            <TextField
              id="descriptionInput"
              label="کلید"
              variant="outlined"
              className={classes.customInput}
              value={coin}
              onChange={(e) => setCoin(e.target.value)}
              type="number"
            />
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddUserAccess} color="primary">
          اضافه کردن
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
